import React, { useEffect, useState } from "react";
import "../assets/css/grossProration.css";
import { calculateSalaryBreakdown } from "../utils/calculateSalaryBreakdown";
import api from "../api/axios";

const GrossProration = ({ salary, salaryConfig, employeeId }) => {
  const [grossProration, setGrossProration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [salaryConfig, setSalaryConfig] = useState({
  //   id: 1,
  //   company_id: 1,
  //   basic_percentage: "50.00",
  //   hra_percentage: "40.00",
  //   medical_allowance_percentage: "5.00",
  //   statutory_bonus_percentage: "25.00",
  //   other_allowance_percentage: "30.00",
  // });

  const { company } = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (salary) {
      setGrossProration(calculateSalaryBreakdown(salary, salaryConfig));
    } else {
      api
        .get(
          `employees/companies/${company.company_id}/employees/${employeeId}/salary-breakdown`,
          {
            params: { month: "2024-11" },
          }
        )
        .then((response) => {
          console.log("response config ", response.data.config);
          // setSalaryConfig(response.data.config);
          setGrossProration(response.data.breakdown);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    }
  }, []);

  return (
    <div className="gross-proration-container">
      <div className="gross-proration">
        <h2>Annual & Monthly CTC</h2>
        <table>
          <thead>
            <tr>
              <th>Salary Components</th>
              <th>Amount Monthly</th>
            </tr>
          </thead>
          {grossProration && (
            <tbody>
              <tr>
                <td>Basic: </td>
                <td> {Number(grossProration?.basic)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>HRA: </td>
                <td>{Number(grossProration?.hra)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Medical Allowance: </td>
                <td>{Number(grossProration?.medicalAllowance)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Statutory Bonus: </td>
                <td>{Number(grossProration?.statutoryBonus)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Other Allowance: </td>
                <td>{Number(grossProration?.otherAllowance)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bolder" }}>Total Pay: </td>
                <td style={{ fontWeight: "bolder" }}>
                  {Number(grossProration?.totalPay)?.toFixed(2)}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default GrossProration;
